//import axios from 'axios';
import http from '@/http';

export default class NotaService {

	getNotas() {
        return http.get('assets/demo/data/notas.json').then(res => res.data.data);
    }

	// getNotas() {
	// 	console.log('getNotas ...');
	// 	return http.get('nota').then(res => res.data);
    // }

	// update(nota) {
	// 	console.log('update ...');
	// 	return http.put(`nota/${nota.id}`, nota).then(res => res.data);
    // }

	// create(nota) {
	// 	console.log('create ...');
	// 	return http.post('nota', nota).then(res => res.data);
    // }

	// delete(nota) {
	// 	console.log('create ...');
	// 	return http.delete(`nota/${nota.id}`).then(res => res.data);
    // }

}
